import { useAuth0 } from '@auth0/auth0-react';
import { Menu, Transition } from '@headlessui/react';
import classNames from 'classnames';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { userIsAdmin, userHasApiAccess } from '../utils/broker';

function Login() {
  const { logout, user } = useAuth0();

  const isAdmin = userIsAdmin(user);
  const hasApiAccess = userHasApiAccess(user);

  return (
    <div className="flex-shrink-0 flex bg-gray-700 p-4">
      <div className="flex-shrink-0 group block">
        <div className="flex items-center">
          <Menu as="div" className="relative flex-shrink-0">
            <div>
              <Menu.Button className="bg-indigo-700 flex text-sm rounded-full text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-700 focus:ring-white">
                <span className="sr-only">Open user menu</span>
                <img
                  className="h-8 w-8 rounded-full"
                  src={user?.picture}
                  alt="User Profile"
                />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="origin-top-right absolute z-10 left-0 bottom-12 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <Menu.Item>
                  {({ active }) => (
                    <Link
                      to="/profile"
                      className={classNames(
                        active ? 'bg-gray-100' : '',
                        'block px-4 py-2 text-sm text-gray-700'
                      )}
                    >
                      View Profile
                    </Link>
                  )}
                </Menu.Item>
                {!!hasApiAccess && (
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/api-access"
                        className={classNames(
                          active ? 'bg-gray-100' : '',
                          'block px-4 py-2 text-sm text-gray-700'
                        )}
                      >
                        API Access
                      </Link>
                    )}
                  </Menu.Item>
                )}
                {!!isAdmin && (
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/settings"
                        className={classNames(
                          active ? 'bg-gray-100' : '',
                          'block px-4 py-2 text-sm text-gray-700'
                        )}
                      >
                        Settings
                      </Link>
                    )}
                  </Menu.Item>
                )}
                <Menu.Item>
                  {({ active }) => (
                    <a
                      href="#"
                      onClick={() =>
                        logout({ returnTo: window.location.origin })
                      }
                      className={classNames(
                        active ? 'bg-gray-100' : '',
                        'block px-4 py-2 text-sm text-gray-700'
                      )}
                    >
                      Logout
                    </a>
                  )}
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
          <div className="ml-3">
            <p className="text-base font-medium text-white">
              {user?.nickname || user?.name}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
